// Canonical CSV serializer for web-side exports. Replaces three divergent
// hand-rolled escapers (two on the server, one in BulkInviteResult) that each
// missed either CR-only line breaks or the formula-injection guard.
//
// Pure, DOM-free: callers own the Blob/data-URL/download plumbing (see
// `lib/download.ts`). RFC 4180 quoting, CRLF row separators.

// Excel/Sheets treats a leading =, +, -, @, tab, or CR as a formula prefix.
// A member-supplied name like `=HYPERLINK("http://evil","click")` would
// otherwise execute when the export is opened. Prefixing with an apostrophe
// forces the cell to render as literal text. Applied before the quoting
// decision so a value like `=1,2` becomes `"'=1,2"`.
const FORMULA_LEAD_RE = /^[=+\-@\t\r]/;
const NEEDS_QUOTING_RE = /["\r\n,]/;

export function csvCell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '';
  let text = String(value);
  if (FORMULA_LEAD_RE.test(text)) {
    text = `'${text}`;
  }
  if (NEEDS_QUOTING_RE.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function csvRow(
  values: ReadonlyArray<string | number | null | undefined>,
): string {
  return values.map(csvCell).join(',');
}

export function buildCsv(
  header: ReadonlyArray<string>,
  rows: ReadonlyArray<ReadonlyArray<string | number | null | undefined>>,
): string {
  const lines = [csvRow(header), ...rows.map(csvRow)];
  return lines.join('\r\n') + '\r\n';
}
